import { shim } from './baseConfigShim';
import { getAppData } from './configData';

const config = shim(getAppData);
export default config;

export type ConfigShimType = typeof config;
